import { render } from "./SemesterSettingsModal.vue?vue&type=template&id=556c1de4&scoped=true"
import script from "./SemesterSettingsModal.vue?vue&type=script&lang=js"
export * from "./SemesterSettingsModal.vue?vue&type=script&lang=js"

import "./SemesterSettingsModal.vue?vue&type=style&index=0&id=556c1de4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556c1de4"]])

export default __exports__